import {expectEither, HttpClient$} from '@raison/network-facade';
import {DoubleString, NonEmptyString, NonNegativeDoubleString} from '@raison/types';
import {array, type, TypeOf} from 'io-ts';
import {atom} from 'jotai';

const DynamicRateSchema = type({
    symbol: NonEmptyString,
    placement_price: NonNegativeDoubleString,
    current_price: NonNegativeDoubleString,
    percent: DoubleString,
});

export const DynamicRatesSchema = array(DynamicRateSchema);
export type DynamicRatesSchema = TypeOf<typeof DynamicRatesSchema>;

export const fetchDynamicRates = atom(get => async () => {
    const http = get(HttpClient$);
    return await http('/v1/assets/grow').then(
        ...expectEither({
            200: DynamicRatesSchema,
        })
    );
});
